<template>
  <header>
    <div class="row">
      <div class="col-auto btn-sm-col">
        <button
          v-if="showBackBtn"
          class="btn btn-nav"
          @click="goBack()"
        >
          <i class="exu-chevron-left"/>
        </button>
        <button
          v-else-if="showEventListBtn"
          class="btn btn-nav"
          @click="toEventList()"
        >
          <i class="exu-log-out-02"/>
        </button>
      </div>
      <div class="col">
          <h1>{{ mainTitle }}</h1>
          <p
            v-if="subTitle"
            class="subtitle"
          >
          {{ subTitle }}
        </p>
      </div>
      <div class="col-auto">
        <button
          v-if="showRightBtn"
          class="btn btn-nav"
          @click="onRightClick"
        >
          <i
            :class="{'exu-menu-01': !showCross, 'exu-x-close': showCross}"
          />
        </button>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'MainHeader',
  props: {
    mainTitle: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: '',
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    // showAsideButton: {
    //   type: Boolean,
    //   default: true,
    // },
    // Настройки открыты. Шапка становится их шапкой: заголовок задаёт App.vue,
    // левая кнопка уходит совсем, правая закрывает панель.
    settingsOpen: {
      type: Boolean,
      default: false,
    },
    btnBack: {
      type: String,
      default: null,
    },
  },
  computed: {
    showBackBtn() {
      return !!this.$route.meta?.showBackBtn && !this.isOpen && !this.settingsOpen;
    },
    showEventListBtn() {
      return !this.settingsOpen && !this.showBackBtn
        && (this.$store.getters.isVisibleBtnToEventList || this.isOpen);
    },
    showRightBtn() {
      return this.settingsOpen || this.$store.getters.isVisibleBtnMenu;
    },
    showCross() {
      return this.isOpen || this.settingsOpen;
    },
  },
  mounted() {
  },
  methods: {
    onRightClick() {
      if (this.settingsOpen) this.$emit('close-settings');
      else this.$emit('aside-click');
    },
    goBack() {
      this.$router.back();
    },
    toEventList() {
      this.$router.push({ name: 'EventsListView' });
    },
  },
};
</script>

<style lang="scss">
header {
  position: sticky;
  top: 0;
  z-index: 600;
  grid-area: header;
  display: grid;
  padding: 0 12px;
  background: #1c1c1c;
  color: #f0f0f0;
  font-family: 'Roboto Condensed';
  // line-height: 1.15rem;

  & > .row {
    align-items: center;
  }

  h1 {
    margin: 0;
    font-size: 16px;
    text-align: center;
    font-weight: 600;

    @media (min-width: 350px) {
      font-size: 20px;
    }
  }
  .subtitle {
    margin: 0;
    font-size: 14px;
    text-align: center;
    font-weight: 400;
  }
  .btn-sm-col {
    width: 40px;
  }
  .btn-nav {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    padding: 0;
    margin: 0;
    border: none;
    color: #fefefe;
    font-size: 20px;
    background: rgba(255,255,255,.05);
    &:hover {
      background: rgba(255,255,255,.05);
    }
  }
}
</style>
